<af-full-table class="w-100 h-100"
               [showImport]="false"
               [showExport]="false"
               [dataSource]="dataSource"
               (tableUpdateListener)="loadTransactions($event)"
               [columnTranslationPrefixes]="{id: 'transactions', date: 'transactions', type: 'transactions'}"
               (emptyStateClickListener)="navigateToCreateTransaction()"
               [filterEvent]="tableEvent.filter"
               [pageEvent]="tableEvent.page"
               [sortEvent]="tableEvent.sortBy"
               [filterFields]="filterFields"
               [hasFilterContent]="true"
               [totalElements]="totalElementsForFilter"
               additionalSpinnerIds="transactions"
               placeholderContext="transactions"
               emptyStateIconName="ic_empty_state_no_data"
               emptyStateTitleTranslationKey="i18n_af_emptyStateTitleTransactionsNotAdded"
               emptyStateSubtitleTranslationKey="i18n_af_emptyStateSubtitleNoData">
    <div FilterContent fxLayout="row" fxLayoutAlign="center center" class="pl-16" fxLayoutGap="16px">
        @if (hasCreateButton) {
            <ui-kit-button [label]="'i18n_af_buttonCreateNewTransaction' | translate"
                           [removePadding]="true"
                           type="text"
                           iconPosition="left"
                           size="small"
                           buttonType="button"
                           icon="ic_plus_ellipse"
                           (clickListener)="navigateToCreateTransaction()"/>
        }
    </div>
</af-full-table>
